import React from 'react';
import { Lock } from 'lucide-react';
import { ModalShell } from '../ui/shell';
import { Btn } from '../ui/primitives';
import { AssessmentSettingForm } from './assessmentSettings';

/**
 * Per-row assessment settings modal — wraps the shared settings form without duplicating logic.
 */
const AssessmentSettingDialog = ({
  open,
  testDetails,
  onClose,
  onSaved,
  saveLocked = false,
  onSaveBlocked,
}) => {
  const [actionState, setActionState] = React.useState({ isLoading: false });

  if (!open || !testDetails) return null;

  const assessmentName = testDetails.name || 'Assessment';
  const formId = 'assessment-settings-form';

  const handleSaveClick = (event) => {
    if (!saveLocked) return;
    event.preventDefault();
    if (onSaveBlocked) onSaveBlocked();
  };

  return (
    <ModalShell
      title="Assessment settings"
      sub={assessmentName}
      onClose={onClose}
      max="680px"
      foot={(
        <>
          <Btn type="button" $variant="ghost" onClick={onClose} disabled={actionState.isLoading}>
            Cancel
          </Btn>
          <Btn
            type={saveLocked ? 'button' : 'submit'}
            form={saveLocked ? undefined : formId}
            $variant={saveLocked ? 'ghost' : 'subtle'}
            disabled={actionState.isLoading}
            onClick={handleSaveClick}
          >
            {saveLocked ? <Lock size={15} strokeWidth={2} aria-hidden="true" /> : null}
            {actionState.isLoading ? 'Saving…' : 'Save changes'}
          </Btn>
        </>
      )}
    >
      <AssessmentSettingForm
        key={testDetails.testId}
        testDetails={testDetails}
        onDismiss={onClose}
        onSaved={onSaved}
        formId={formId}
        onActionStateChange={setActionState}
        showInlineFooter={false}
        saveDisabled={saveLocked}
      />
    </ModalShell>
  );
};

export default AssessmentSettingDialog;
